import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { UnifiedLayout } from "./ui/unified-layout";

export const createUnifiedLayout = (...rest: RouteObject[]): RouteObject => {
  return {
    element: createElement(UnifiedLayout),
    children: [...rest],
  };
};

